import React, { useState } from 'react';
import { encodeShare } from '../share';
import type { ContentPack, BuildState } from '../../packs/types';
import type { Adapters } from '../../adapters/types';

interface ExportPanelProps {
  pack: ContentPack;
  build: BuildState;
  adapters: Adapters;
  payloadToShare: any;
  exportPng: (size: 64 | 128) => void;
  exportAns: (format: 'truecolor' | 'xterm256', variant: '64' | '120' | '128') => void;
  exportSvg: () => void;
  getPngDataUrl: (size: 64 | 128) => string | null;
}

export function ExportPanel({ pack, build, adapters, payloadToShare, exportPng, exportAns, exportSvg, getPngDataUrl }: ExportPanelProps) {
  const [ansOpen, setAnsOpen] = useState(false);
  const namingLabel = pack.metadata?.namingLabel ?? 'Ship';

  return (
    <div className="px-2 pb-4 flex flex-col gap-2">
      <div className="flex gap-2">
        <button className="flex-1 text-sm font-medium py-2 rounded-lg bg-slate-800 text-slate-300" onClick={() => exportPng(64)}>PNG 64</button>
        <button className="flex-1 text-sm font-medium py-2 rounded-lg bg-slate-800 text-slate-300" onClick={() => exportPng(128)}>PNG 128</button>
        <button className="flex-1 text-sm font-medium py-2 rounded-lg bg-slate-800 text-slate-300" onClick={exportSvg}>SVG</button>
      </div>
      <button
        className="w-full text-sm font-medium py-2 rounded-lg bg-indigo-900 text-indigo-300"
        onClick={async () => {
          const encoded = encodeShare(pack.id, pack.version, payloadToShare);
          const imageData = getPngDataUrl(128);
          await adapters.share.share(encoded, {
            name: build.name ?? `My ${namingLabel}`,
            image: imageData ?? undefined
          });
        }}
      >
        Share
      </button>
      <button
        className="text-xs text-slate-500 hover:text-slate-400 text-left flex items-center gap-1"
        onClick={() => setAnsOpen(o => !o)}
      >
        <span style={{ fontSize: 9 }}>{ansOpen ? '▼' : '▶'}</span> ANS export
      </button>
      {ansOpen && (
        <div className="grid grid-cols-2 gap-1">
          <button className="text-xs py-1.5 rounded text-slate-400 bg-slate-800" onClick={() => exportAns('truecolor', '64')}>Truecolor 64</button>
          <button className="text-xs py-1.5 rounded text-slate-400 bg-slate-800" onClick={() => exportAns('truecolor', '120')}>Truecolor 120</button>
          <button className="text-xs py-1.5 rounded text-slate-400 bg-slate-800" onClick={() => exportAns('xterm256', '64')}>256-color 64</button>
          <button className="text-xs py-1.5 rounded text-slate-400 bg-slate-800" onClick={() => exportAns('xterm256', '120')}>256-color 120</button>
        </div>
      )}
    </div>
  );
}
